import styled from 'styled-components';
import {
  screenSize,
  whiteColor,
  inputBackgroundColor,
  inputBorderColor,
  mediumFont,
  primaryColor,
} from '@app/styles';

export const InputContainer = styled.div`
  position: relative;
  margin-bottom: 20px;
  svg {
    position: absolute;
    right: 15px;
    top: 37px;
    color: #979cab;
  }
`;

export const InputComponent = styled.input`
  width: 100%;
  height: 48px;
  padding: 10px 32px 10px 12px;
  border: 1px solid ${inputBorderColor};
  border-radius: 3px;
  color: #2d3448;
  box-shadow: none;
  outline: none;
  -webkit-appearance: none;
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
  @media (${screenSize.tablet}) {
    background-color: ${inputBackgroundColor};
    border-color: ${inputBorderColor};
    &:hover {
      background-color: ${whiteColor};
      border-color: ${primaryColor};
    }
    &:active,
    &:focus {
      background-color: ${whiteColor};
      border-color: ${primaryColor};
    }
  }
`;

export const Label = styled.label`
  font-size: 15px;
  color: #0f1d2a;
  opacity: 0.5;
  text-align: left;
  line-height: 21px;
  ${mediumFont}
`;
